import { useState } from 'react';
import { Card, CardContent } from 'components/shadcn/ui/card';
import { HGTable, TableSkeleton } from 'components/HGTable';
import { useGetIDsFromURL } from 'components/DeviceDetails/helper';
import { batteryStacksTableColumns } from './columns';

const BatteryStacksTable = ({ mastersConfigs, activeAlerts, loading }) => {
    const tableData = mastersConfigs?.map((config) => ({
        ...config,
        active_alerts: activeAlerts,
    }));
    const { Thing_ID } = useGetIDsFromURL();
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState(1);

    return (
        <Card>
            <CardContent className="p-6">
                {loading ? (
                    <>
                        <h4 className="pb-2 text-lg font-semibold">
                            Battery Stacks
                        </h4>
                        <TableSkeleton columns={batteryStacksTableColumns} />
                    </>
                ) : !tableData || tableData?.length === 0 ? (
                    <div className="mb-8 mt-12 flex flex-col items-center justify-center">
                        <h2 className="text-center opacity-20">
                            No Battery Stacks Available
                        </h2>
                    </div>
                ) : (
                    <>
                        <h4 className="pb-2 text-lg font-semibold">Battery Stacks</h4>
                        <HGTable
                            columns={batteryStacksTableColumns}
                            data={tableData}
                            rowsHref={(item) =>
                                `/devices/${Thing_ID}/${item.MASTER_SN}`
                            }
                            sortField={sortField}
                            setSortField={setSortField}
                            sortDirection={sortDirection}
                            setSortDirection={setSortDirection}
                            currentPage={1}
                            setCurrentPage={() => {}}
                            pageSize={tableData.length}
                            totalItems={tableData.length}
                        />
                    </>
                )}
            </CardContent>
        </Card>
    );
};

export default BatteryStacksTable;
